define((require) => {
    "use strict";

    const ChunkingCollectionQuery = require("data/ChunkingCollectionQuery");

    const TYPE_AND = "And";
    const TYPE_OR = "Or";

    const FilterQuery = ChunkingCollectionQuery.extend("FilterQuery", {

        /**
         * Constructor.
         *
         * @param {String} [type=TYPE_AND] In case *this* filter query includes multiple expressions, this defines the root type.
         */
        constructor(rootType = TYPE_AND) {
            this.__super();

            this.rootType = rootType;

            this._expressions = [];
        },

        and(...expressions) {
            return this._addExpressions(expressions, "And");
        },

        or(...expressions) {
            return this._addExpressions(expressions, "Or");
        },

        // Doesn't add any types to each expression. Useful to query with only the root type.
        useRoot(...expressions) {
            expressions.forEach((expression) => {
                this._expressions.push(expression.toJSON());
            });

            return this;
        },

        querify() {
            let query = this._expressions[0];

            if (this._expressions.length > 1) {
                query = {
                    [this.rootType]: this._expressions
                };
            }

            return {
                filter: JSON.stringify(query)
            };
        },

        clone() {
            const clone = new FilterQuery();

            clone._expressions = this._expressions.slice(0);

            return clone;
        },

        _addExpressions(expressions, type) {
            const json = expressions.map((expression) => (expression.toJSON()));

            this._expressions.push({
                [type]: json
            });

            return this;
        }

    }, {

        TYPE_AND,
        TYPE_OR

    });

    return FilterQuery;
});



// WEBPACK FOOTER //
// ./src/editor/data/FilterQuery.js